import { render, staticRenderFns } from "./payment-type-ledger-list.vue?vue&type=template&id=182a1b96"
import script from "./payment-type-ledger-list.vue?vue&type=script&lang=ts"
export * from "./payment-type-ledger-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182a1b96')) {
      api.createRecord('182a1b96', component.options)
    } else {
      api.reload('182a1b96', component.options)
    }
    module.hot.accept("./payment-type-ledger-list.vue?vue&type=template&id=182a1b96", function () {
      api.rerender('182a1b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/payment-type-ledger-list.vue"
export default component.exports